<template>
    <div class="border-t last:border-b py-2" data-cy="card_profile_address_delivery_item">
        <div class="font-bold text-lg" data-cy="text_profile_address_delivery_item_name">
            {{address.addressName}}
            <span v-if="address.isDefault"
                  class="bg-green-400 text-sm font-normal text-white px-2 rounded-md ml-2" data-cy="text_profile_address_delivery_item_default">
                {{lbl.shipping.defaultAddress}}
            </span>
        </div>
        <div class="font-bold text-blue-800" data-cy="text_profile_address_delivery_item_fullname">
            {{address.firstname}} {{address.lastname}}
        </div>
        <div class="text-gray-400" data-cy="text_profile_address_delivery_item_address">
            {{address.address}}
            {{address.subDistrictName}}
            {{address.districtName}}
            {{address.provinceName}}
            {{address.zipcode}}
        </div>
        <div class="pt-2">
            <button class="bg-yellow-500 text-white py-1 px-4 rounded-md text-sm mr-2" @click="onEditAddress()" data-cy="btn_profile_address_delivery_item_edit">Edit</button>
            <button class="bg-red-700 text-white py-1 px-4 rounded-md text-sm" @click="onDeleteAddress()" data-cy="btn_profile_address_delivery_item_delete">Delete</button>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
/**
 * @event onDeleteSuccess
 */
export default {
    name: "AddressListItem",
    mixins: [LocaleMixin],
    props: {
        address: Object,
    },
    methods: {
        onDeleteAddress: function() {
            this.$emit('onDeleteAddress', this.address);
        },
        onEditAddress: function() {
            this.$emit('onEditAddress', this.address);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
